var _defs, _tspan, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCqe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 363.90085,
    viewBox: "0 0 132.29166 96.282102",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-200.7179)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D5    \\uE1D7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(0.98472294,0,0,0.98472294,-8.943857e-7,22.893695)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 29.104245,253.70439 c -1.924247,-1.68372 -4.570088,-2.52558 -7.69699,-2.52558 -11.9062818,0 -21.40725409173874,8.77938 -21.40725409173874,18.16009 0,5.65248 4.57008799173874,9.01991 10.46309609173874,9.01991 9.621238,0 21.52752,-9.01991 21.52752,-18.16009 v -79.61574 h -2.886372 z",
    id: "path4265"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 123.27963,207.64271 c -4.93089,-7.57672 -9.01991,-15.51424 -10.4631,-24.77469 -0.36079,-1.56345 -1.08239,-2.04451 -2.88637,-2.04451 -0.48106,0 -0.96212,0.12027 -0.96212,0.84186 v 0.12027 c 0,0 0,0.24053 0,0.48106 v 22.60991 c 0,0 0,0 0,0 v 48.58725 c -1.92425,-1.68372 -4.57009,-2.52558 -7.69699,-2.52558 -11.906284,0 -21.407257,8.77938 -21.407257,18.03982 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621238,0 21.527521,-8.89964 21.527521,-18.03982 V 205.959 c 5.89301,3.72822 12.98867,14.31159 15.99531,21.28698 1.44318,3.24717 2.28504,8.77938 2.28504,14.43186 0,4.32956 -0.60133,8.89965 -2.28504,13.2292 -0.12027,0.48106 -0.24053,0.96213 -0.24053,1.44319 0,1.44318 0.96212,2.40531 1.56345,2.7661 l 0.12026,0.12027 c 0.84186,0 2.04452,-0.3608 2.52558,-1.92425 0,0 2.52557,-9.14017 2.52557,-16.7169 0,-12.02655 -5.05115,-23.3315 -11.06442,-32.95274 z",
    id: "path4267"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqe);
export default __webpack_public_path__ + "static/media/cqe.cd947c08e77d8ecd3cf60ea856729377.svg";
export { ForwardRef as ReactComponent };